// 服务模块分组数据（Service 与 SearchPage 共用）
// 所有条目均配置 path：无专属页面的走 SvcPage 通用子页（见 data/svcPages.js）
export default [
        {
          name: '就业创业',
          items: [
            { title: '就业见习', icon: 'svc-employ', expand: true, children: [
              { title: '个人就业见习岗位申请', path: '/job-internship-apply' },
              { title: '见习人员确认', path: '/internship-confirm' }
            ] },
            { title: '就业补贴', icon: 'svc-subsidy', expand: true, children: [
              { title: '求职创业补贴个人申报', path: '/subsidy-apply' }
            ] },
            { title: '失业登记', icon: 'svc-unemploy', path: '/unemploy-register' },
            { title: '失业登记查询', icon: 'svc-unemploy-query', path: '/unemploy-query' },
            { title: '就业困难人员认定', icon: 'svc-hardship', path: '/hardship-certify' },
            { title: '用工备案信息查询', icon: 'svc-record', path: '/work-record-query' },
            { title: '培训效果评价', icon: 'svc-train-eval', path: '/training-evaluate' },
            { title: '培训补贴办理', icon: 'svc-train-subsidy', path: '/training-subsidy' },
            { title: '培训证书查询', icon: 'svc-train-cert', path: '/training-cert-query' },
            { title: '个人富民创业担保贷款申请（资质认定）', icon: 'svc-loan', path: '/loan-apply' },
            { title: '就业创业证查询', icon: 'svc-cert-query', path: '/job-cert-query' },
            { title: '个人就业困难人员认定信息查询', icon: 'svc-hardship-info', path: '/hardship-info-query' },
            { title: '个人就业创业扶持政策享受情况查询', icon: 'svc-policy', path: '/policy-query' }
          ]
        },
        {
          name: '社会保险',
          items: [
            { title: '个人权益记录查询打印', icon: 'svc-rights-print', path: '/rights-record-print' },
            { title: '待遇资格认证', icon: 'svc-treatment', path: '/qualification-certify' },
            { title: '企业养老保险待遇发放账户变更', icon: 'svc-pension-change', path: '/pension-account-change' },
            { title: '企业职工基本养老保险', icon: 'svc-pension', expand: true, children: [
              { title: '灵活就业人员就业和社会保险登记', path: '/flexible-registration' },
              { title: '灵活就业人员停保登记', path: '/flexible-deregistration' },
              { title: '企业退休人员体检预约', path: '/retiree-exam-booking' },
              { title: '参保信息查询', path: '/pension-insured-query' },
              { title: '参保变更信息查询', path: '/pension-change-query' },
              { title: '缴费记录查询', path: '/pension-payment-query' },
              { title: '企业离退休信息查询', path: '/retiree-info-query' },
              { title: '养老待遇发放查询', path: '/pension-benefit-query' },
              { title: '过渡性养老金调整情况查询', path: '/transition-pension-query' },
              { title: '养老金调整情况查询', path: '/pension-adjust-query' }
            ] },
            { title: '机关事业单位养老保险', icon: 'svc-gov-pension', expand: true, children: [
              { title: '机关事业单位养老保险缴费记录查询', path: '/gov-pension-payment-query' },
              { title: '机关事业单位养老保险缴费证明', path: '/gov-pension-payment-cert' },
              { title: '机关事业单位养老保险待遇发放查询', path: '/gov-pension-benefit-query' },
              { title: '机关事业单位养老保险待遇领取证明', path: '/gov-pension-benefit-cert' },
              { title: '机关事业单位年度调待明细查询', path: '/gov-pension-adjust-query' },
              { title: '职业年金个人缴费情况查询', path: '/occupational-annuity-payment-query' },
              { title: '职业年金待遇核定结果查询', path: '/occupational-annuity-result-query' },
              { title: '职业年金待遇核定进度查询', path: '/occupational-annuity-progress-query' },
              { title: '职业年金支付计划查询', path: '/occupational-annuity-plan-query' }
            ] },
            { title: '工伤保险', icon: 'svc-injury', expand: true, children: [
              { title: '参保信息查询', path: '/injury-insured-query' },
              { title: '参保变更信息查询', path: '/injury-change-query' },
              { title: '缴费记录查询', path: '/injury-payment-query' },
              { title: '工伤基本信息', path: '/injury-base-info' },
              { title: '供养基本情况查询', path: '/injury-support-query' },
              { title: '工伤待遇支付明细查询', path: '/injury-benefit-query' },
              { title: '工伤供养亲属待遇信息', path: '/injury-relative-benefit' },
              { title: '工伤异地居住（就医）申请', path: '/injury-remote-apply' },
              { title: '一次性工伤医疗补助金申领', path: '/injury-medical-grant' },
              { title: '伤残待遇申领（一次性伤残补助金、伤残津贴）', path: '/injury-disability-apply' }
            ] },
            { title: '失业保险', icon: 'svc-unemployment', expand: true, children: [
              { title: '失业登记', path: '/unemploy-register' },
              { title: '失业登记查询', path: '/unemploy-query' },
              { title: '待遇资格认证', path: '/qualification-certify' }
            ] },
            { title: '城乡居民服务', icon: 'svc-resident', expand: true, children: [
              { title: '城乡居民养老保险线上业务表格打印', path: '/resident-form-print' },
              { title: '城乡居民基本养老保险费补缴', path: '/resident-supplement-pay' },
              { title: '城乡居民养老保险暂停缴费', path: '/resident-pause-pay' },
              { title: '城乡居民参保信息查询', path: '/resident-insured-query' },
              { title: '城乡居民养老保险待遇核定', path: '/resident-benefit-check' },
              { title: '城乡居民待遇标准信息查询', path: '/resident-standard-query' },
              { title: '城乡居民待遇人员发放信息查询', path: '/resident-grant-query' },
              { title: '城乡居民基本养老保险参保登记', path: '/resident-registration' },
              { title: '城乡居民缴费记录查询', path: '/resident-payment-query' }
            ] },
            { title: '职业伤害保障', icon: 'svc-occupational', expand: true, children: [
              { title: '参保信息查询', path: '/occupational-insured-query' },
              { title: '职业伤害确认信息查询', path: '/occupational-confirm-query' }
            ] },
            { title: '退休一件事', icon: 'svc-retirement', path: '/one-thing' }
          ]
        },
        {
          name: '人才人事',
          items: [
            { title: '技能人员职业资格证书查询', icon: 'svc-skill-cert', path: '/skill-cert' },
            { title: '档案转出', icon: 'svc-archive-out', path: '/archive-out' },
            { title: '依据档案记载出具相关证明', icon: 'svc-archive-proof', path: '/archive-proof' },
            { title: '档案接收', icon: 'svc-archive-in', path: '/archive-in' },
            { title: '流动人员人事档案查询', icon: 'svc-archive-query', path: '/archive-query' },
            { title: '代理单位查询', icon: 'svc-agent-query', path: '/agent-query' },
            { title: '出国劳务人员换证查询', icon: 'svc-abroad-cert', path: '/abroad-cert-query' },
            { title: '专项职业能力证书查询', icon: 'svc-ability-cert', path: '/ability-cert-query' },
            { title: '职业技能等级认定证书查询', icon: 'svc-grade-cert', path: '/grade-cert-query' },
            { title: '全国计算机高新技术考试合格证书查询', icon: 'svc-gjk-cert', path: '/computer-cert' },
            { title: '培训、评价机构信息查询', icon: 'svc-org-query', path: '/org-query' }
          ]
        },
        {
          name: '劳动关系',
          items: [
            { title: '劳动人事争议调解申请', icon: 'svc-dispute', path: '/labor-dispute-mediation' },
            { title: '劳动保障监察投诉登记、调查、处理', icon: 'svc-complaint', path: '/labor-complaint' },
            { title: '劳动保障监察举报登记、调查、处理', icon: 'svc-report', path: '/labor-report' },
            { title: '劳动保障监察案件查询', icon: 'svc-case-query', path: '/labor-case-query' },
            { title: '欠薪线索反映', icon: 'svc-wage-clue', path: '/wage-clue-report' },
            { title: '农民工考勤查询', icon: 'svc-attendance', path: '/migrant-attendance-query' },
            { title: '农民工工资核算确认', icon: 'svc-wage-calc', path: '/migrant-wage-calc' },
            { title: '离场结算清算确认', icon: 'svc-leave-settle', path: '/leave-settle-confirm' },
            { title: '个人案件办理跟踪', icon: 'svc-case-track', path: '/case-list' },
            { title: '工资异议申诉', icon: 'svc-wage-appeal', path: '/wage-appeal' },
            { title: '项目履历查询', icon: 'svc-project-history', path: '/project-history-query' },
            { title: '个人投诉、举报查询', icon: 'svc-complaint-query', path: '/complaint-query' },
            { title: '工资异议核处', icon: 'svc-wage-handle', path: '/wage-handle' },
            { title: '个人欠薪线索查询', icon: 'svc-wage-clue-query', path: '/wage-clue-query' },
            { title: '农民工用工协议签名', icon: 'svc-agreement-sign', path: '/agreement-sign' },
            { title: '农民工用工协议查询', icon: 'svc-agreement-query', path: '/agreement-query' }
          ]
        },
        {
          name: '社会保障卡',
          items: [
            { title: '社会保障卡申领', icon: 'svc-card-apply', path: '/social-card' },
            { title: '社会保障卡启用', icon: 'svc-card-enable', path: '/card-enable' },
            { title: '电子社保卡申领', icon: 'svc-ecard-apply', path: '/e-card' },
            { title: '社会保障卡正式挂失与解挂', icon: 'svc-card-loss', path: '/card-loss' },
            { title: '社会保障卡补卡', icon: 'svc-card-replace', path: '/card-replace' },
            { title: '社保卡信息查询', icon: 'svc-card-query', path: '/social-card-query' },
            { title: '制卡进度查询', icon: 'svc-card-progress', path: '/card-progress-query' },
            { title: '社会保障卡注销', icon: 'svc-card-cancel', path: '/card-cancel' }
          ]
        }
      ]



// WEBPACK FOOTER //
// ./src/data/services.js